import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-icon',
  imports: [],
  templateUrl: './reports-icon.html',
  styleUrl: './reports-icon.css'
})
export class ReportsIcon {

}
